import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const deleteQnsBankcApi = createAsyncThunk(
    'qns-bank/delete',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.questionBankAction(`update/${data}`, 0))
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const deleteQnsBankcSlice = createSlice({
    name: 'qns-bank/delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(deleteQnsBankcApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(deleteQnsBankcApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(deleteQnsBankcApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const deleteQnsBankcReducer = deleteQnsBankcSlice.reducer